<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group-template
        *formationGroup="{title: 'wbo.category.edit.formation.details', formControlNames: []}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="parent">
                        <wbo-category-single-select-edit-control formControlName="categoryId"
                                                                 [(ngModel)]="model.data.parent.categoryId"
                                                                 [readonly]="true"></wbo-category-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name"
                                               (valueChange)="categoryNameChanged()"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="exportCode"
                                               [(ngModel)]="model.data.exportCode"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="applyMinimumAge"
                                                        [(ngModel)]="model.data.applyMinimumAge"
                                                        [placeholder]="applyMinimumAgePlaceholder"
                                                        [clearSelectionOptionLabel]="applyMinimumAgePlaceholder">
                            <wbo-select-options>
                                <wbo-select-option [label]="'wbo.category.edit.option.applyMinimumAge.yes'"
                                                   [value]="true"></wbo-select-option>
                                <wbo-select-option [label]="'wbo.category.edit.option.applyMinimumAge.no'"
                                                   [value]="false">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="reorderableInApp"
                                                        [(ngModel)]="model.data.reorderableInApp"
                                                        [placeholder]="reorderableInAppPlaceholder"
                                                        [clearSelectionOptionLabel]="reorderableInAppPlaceholder">
                            <wbo-select-options>
                                <wbo-select-option [label]="'wbo.category.edit.option.reorderableInApp.yes'"
                                                   [value]="true"></wbo-select-option>
                                <wbo-select-option [label]="'wbo.category.edit.option.reorderableInApp.no'"
                                                   [value]="false">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-color-edit-control formControlName="rgbaColour"
                                                [(ngModel)]="model.data.rgbaColour"></wbo-color-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
